import { Controller } from 'stimulus';

export default class extends Controller {
  ask(ev) {
    if (!confirm('Are you sure?')) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }
}
